var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendDownDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.222 1.49071C12.1797 1.25746 11.9755 1.08058 11.7301 1.08058L11.6402 1.08864C11.4069 1.13097 11.2301 1.33512 11.2301 1.58058L11.2301 10.273L1.12347 0.166368L1.05422 0.108513C0.859355 -0.0264831 0.589931 -0.00719806 0.416365 0.166368C0.221102 0.361631 0.221103 0.678213 0.416365 0.873475L10.523 10.9801L1.83058 10.9801L1.7407 10.9881C1.50745 11.0305 1.33058 11.2346 1.33058 11.4801C1.33058 11.7562 1.55444 11.9801 1.83058 11.9801L11.7301 11.9801L11.8199 11.972C12.0532 11.9297 12.2301 11.7255 12.2301 11.4801L12.2301 1.58058L12.222 1.49071Z",
    fill: "#23252C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendDownDark);
export default __webpack_public_path__ + "static/media/trend-down-dark.83e7f41454abcf81ab3d6aa94dbf472a.svg";
export { ForwardRef as ReactComponent };